import { useContext } from 'react';
import { CatalogList } from '../../../../CatalogList';
import { CatalogGrid } from '../../../CatalogGrid/CatalogGrid';
import '../../radius.css';
import { UserContext } from '../../../../../auth/context/UserContext';

export const UngroupedProducts = ({
  products,
  isMobile,
  dataClient,
  onProductClick,
}) => {

  const { dataUser } = useContext(UserContext);
  const { visualizaStock } = dataUser;

  return (
    <div className="ungrouped-products-section">
      {!isMobile ? (
        <div className="contenedortabla">
          <table className="tabla">
            <thead className="tabla__encabezado">
              <tr>
                <th className="tabla__titulo tabla__media codigo">Código</th>

                <th className="tabla__titulo tabla__media codigo_sin">
                  Sinónimo
                </th>

                <th className="tabla__titulo tabla__desc descripcion">
                  Descripción
                </th>
                {visualizaStock ? (
                  <th className="tabla__titulo tabla__media stocks tabla__num">
                    Stock
                  </th>
                ) : (
                  <th></th>
                )}

                <th
                  className={
                    !dataClient
                      ? 'tabla__titulo tabla__precio precio tabla__num'
                      : 'tabla__titulo tabla__precio precios tabla__num'
                  }
                >
                  Precio
                </th>
                {dataClient && (
                  <th
                    className="tabla__titulo cell-actions-table"
                    style={{
                      borderBottomRightRadius: '4px',
                      borderTopRightRadius: '4px',
                    }}
                  >
                    Cantidad
                  </th>

                )}
              </tr>
            </thead>
            <tbody>

              <CatalogList
                lisArt={products}
                onProductClick={onProductClick}
                dataClient={dataClient}
              />

            </tbody>
          </table>
        </div>
      ) : (
        <CatalogGrid lisArt={products} onProductClick={onProductClick} />
      )}
    </div>
  );
};
